import { scrollToTargetAdjusted } from "@libs/helper/scrollToTargetAdjusted";
import { Button, Image, Spin } from "antd";
import classNames from "classnames";
import { observer } from "mobx-react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

const MorableButton = observer(
  ({
    isOpen,
    onClick = () => {},
    className = "",
    loading = false,
    underline = false,
    scrollBackOnShowLess,
    scrollableAncestorRef,
    roomDescLength,
    allNumber,
  }) => {
    const { t } = useTranslation("common");
    const buttonRef = useRef(null);

    const handleClick = () => {
      onClick();
      if (isOpen && scrollBackOnShowLess) {
        const target = scrollableAncestorRef?.current;
        scrollToTargetAdjusted(target);
      }
    };
    return (
      <Button
        onClick={handleClick}
        type={"link"}
        className={`pl-0 !border-none`}
        ref={buttonRef}
      >
        {loading ? (
          <div className={"z-20"}>
            <Spin />
          </div>
        ) : (
          <div
            className={classNames(
              "text-green flex flex-row space-x-2 items-center p-0 text-base",
              className
            )}
          >
            <div
              className={classNames("text-green text-base font-normal", {
                underline: underline,
              })}
            >
              {!isOpen ? t("offer.seemore") : t("offer.seeless")}
            </div>
            <div>
              <Image
                className={classNames("active-arrow mt-[3px]", {
                  "active-arrow-open": isOpen ? false : true,
                })}
                src="/static/icons/arup.svg"
                alt="arrow up icon"
                width={"100%"}
                height={"100%"}
                loading="lazy"
                preview={false}
              />
            </div>
          </div>
        )}
      </Button>
    );
  }
);
export default MorableButton;
